import { NgClass } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, ViewChild, input, output } from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'shared-modal-container',
  imports: [IconComponent, NgClass, ButtonDirective],
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalContainerComponent implements AfterViewInit {
  readonly headline = input.required<string>();
  readonly isDialogPositionUp = input<boolean>(false);
  readonly maxWidth = input<string>('30rem');
  readonly contentStyleClass = input<string | undefined>(undefined);
  readonly showCloseButton = input<boolean>(true);

  readonly closeModal = output();

  @ViewChild('body') bodyRef: ElementRef | undefined;

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.bodyRef != null) {
        this.bodyRef.nativeElement.scrollTop = 0;
      }
    }, 100);
  }

  emitCloseForm(): void {
    this.closeModal.emit();
  }
}
